<!--
 * @Author: zxf
 * @Date: 2022-07-26 22:24:00
 * @LastEditors: zry
 * @LastEditTime: 2023-07-04 17:05:35
 * @Description: 故障台账明细新增/修改
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-80 o-dialog--lg-60 o-dialog--xl-50"
    :title="dlTitle"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <el-form
      ref="fd"
      class="c-form"
      :model="fd"
      :rules="dlType==='edit'? fdUpdateRules:fdSaveRules"
      :inline="true"
      label-position="right"
      label-width="110px"
      label-suffix="："
    >
      <el-row
        class="c-form__row"
      >
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="故障情况"
            prop="qkms"
          >
            <el-input
              v-model="fd.qkms"
              class="c-form__input"
              type="textarea"
              rows="4"
              placeholder="请输入故障情况描述"
            />
          </el-form-item>
        </el-col>

        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="故障发现人"
            prop="gzfxr"
          >
            <el-input
              v-model="fd.gzfxr"
              class="c-form__input"
              rows="4"
              placeholder="请输入故障发现人"
            />
            <!--            <select-xm-user-->
            <!--              v-model="fd.wbryDmList"-->
            <!--              role-code="WBRY"-->
            <!--              :show-dept="false"-->
            <!--              multiple-->
            <!--              collapse-tags-->
            <!--            />-->
          </el-form-item>
        </el-col>

        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="发现时间"
            prop="gzfxsj"
          >
            <el-date-picker
              v-model="fd.gzfxsj"
              type="date"
              placeholder="选择故障发现时间"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="维修时间"
            prop="wxsj"
          >
            <el-date-picker
              v-model="fd.wxsj"
              type="date"
              placeholder="选择维修时间"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="维修人员"
            prop="wxry"
          >
            <el-input
              v-model="fd.wxry"
              class="c-form__input"
              rows="4"
              placeholder="请输入维修人员"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="维修方法"
            prop="wxff"
          >
            <el-input
              v-model="fd.wxff"
              class="c-form__input"
              type="textarea"
              rows="4"
              placeholder="请输入维修方法"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="排除确认"
            prop="gzpcqr"
          >
            <el-select
              v-model="fd.gzpcqr"
              placeholder="请选择排除确认"
              clearable
            >
              <el-option
                v-for="item in [{value: '1', label: '执行中'}, {value: '2', label: '已维修'}]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleSave()"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
// import { wbjhService } from '@/features/xfwbgl/wbjh/wbjh.service';
import { gzwxService } from '@/features/xfwbgl/gzwx/gzwx.service';
export default {
  name: 'GzwxDialog',
  props: {
    dlParams: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false, // 页面loading计划年份
      dialogShow: true, // 模态框dialog显示

      wbryList: [], // 维保人员列表
      /* 表单参数 Start */
      fd: {
        uuid: null,
        xmId: null, // 项目ID
        sjssbmDm: null, // 数据所属部门
        gzfxsj: null, // 故障发现时间
        gzfxr: null, // 故障发现人
        qkms: null, // 故障情况描述
        wxsj: null, // 维修时间
        wxry: null, // 维修人员
        wxff: null, // 维修方法
        gzpcqr: null, // 故障排除确认
        tsbz: null // 推送标志
      },
      /* 表单参数 End */

      /* 表单校验规则 Start */
      fdSaveRules: {
        gzfxsj: [
          this.$HMValidator.required('故障发现时间')
        ],
        gzfxr: [
          this.$HMValidator.required('故障发现人')
        ],
        qkms: [
          this.$HMValidator.required('故障情况描述')
        ]
      },
      fdUpdateRules: {
        wxry: [
          this.$HMValidator.required('维修人员')
        ],
        wxsj: [
          this.$HMValidator.required('维修时间')
        ],
        wxff: [
          this.$HMValidator.required('维修方法')
        ]
      },
      /* 表单校验规则 End */
      dlType: 'edit' // 模态框类型
    };
  },
  computed: {
    /* 根据模态框类型动态展示标题 */
    dlTitle () {
      return `${this.dlType === 'edit' ? '编辑' : '查看'}`;
    }
  },
  methods: {
    /**
     * @description: 页面初始化
     * @return {*}
     */
    async init () {
      const _this = this;
      _this.queryGzwxDetail();// 获取合同有效范围内的客户列表
    },
    /**
     * @description: 查询故障台账明细
     * @return {*}
     */
    queryGzwxDetail () {
      const _this = this;
      if (_this.dlType === 'edit') {
        console.log('this.fd.uuid', _this.fd.uuid);

        gzwxService.getInfo(_this.fd.uuid)
          .then(rsp => {
            _this.fd = rsp.data;
          })
          .catch(err => {
            console.error('查询故障台账明细错误！', err);
          });
      }
    },
    /**
     * @description: 保存操作
     * @param {*}
     * @return {*}
     */
    handleSave () {
      this.$refs.fd.validate((valid) => {
        if (valid) {
          this.loading = true;
          if (this.fd.wxry) {
            this.fd.gzpcqr = '2';
          } else {
            this.fd.gzpcqr = '1';
          }
          gzwxService.save(this.fd)
            .then(rsp => {
              this.$alert('新增成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              this.$emit('closeDialog', '');
              this.$emit('callback');
            })
            .catch(err => {
              console.error('新增台账错误！', err);
              this.loading = false;
            });
        }
      });
    },
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  created () {
    this.dlType = this.dlParams.dlType;
    if (this.dlType === 'edit') {
      this.fd.uuid = this.dlParams.id;
    }
    this.fd.xmId = this.dlParams.xmId;
    console.log('this.dlParams', this.dlParams);
    this.init();
  }
};
</script>
